import { render, staticRenderFns } from "./SelectCompanyPrompt.vue?vue&type=template&id=4da9a20c&scoped=true"
import script from "./SelectCompanyPrompt.vue?vue&type=script&lang=js"
export * from "./SelectCompanyPrompt.vue?vue&type=script&lang=js"
import style0 from "./SelectCompanyPrompt.vue?vue&type=style&index=0&id=4da9a20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da9a20c",
  null
  
)

export default component.exports